import React from 'react';

export const Doppelhaushaelfte: React.FC = () => (
  <>
    <g data-testid="Doppelhaushaelfte" clipPath="url(#clip0_4148_206804)">
      <rect width="636" height="493" fill="white" />
      <line
        x1="557.404"
        y1="301.832"
        x2="569.831"
        y2="311.596"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="1"
        y1="-1"
        x2="16.8045"
        y2="-1"
        transform="matrix(-0.786318 0.617822 0.617822 0.786318 592 302)"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="557.404"
        y1="328.832"
        x2="569.831"
        y2="338.596"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="1"
        y1="-1"
        x2="16.8045"
        y2="-1"
        transform="matrix(-0.786318 0.617822 0.617822 0.786318 592 329)"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M577.996 459H570V274.038C570 271.808 571.791 270 574 270C576.209 270 578 271.808 578 274.038V459H577.996Z"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M547 290C546.448 290 546 290.448 546 291V293H548V291C548 290.448 547.552 290 547 290Z"
        fill="black"
      />
      <path
        d="M553 290C552.448 290 552 290.448 552 291V293H554V291C554 290.448 553.552 290 553 290Z"
        fill="black"
      />
      <path
        d="M595 290C594.448 290 594 290.448 594 291V293H596V291C596 290.448 595.552 290 595 290Z"
        fill="black"
      />
      <path
        d="M601 290C600.448 290 600 290.448 600 291V293H602V291C602 290.448 601.552 290 601 290Z"
        fill="black"
      />
      <path
        d="M605.991 302H542.009C541.449 302 541 301.495 541 300.874V295.126C541 294.501 541.453 294 542.009 294H605.991C606.551 294 607 294.505 607 295.126V300.874C607.004 301.495 606.551 302 605.991 302Z"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M547 317C546.448 317 546 317.448 546 318V320H548V318C548 317.448 547.552 317 547 317Z"
        fill="black"
      />
      <path
        d="M553 317C552.448 317 552 317.448 552 318V320H554V318C554 317.448 553.552 317 553 317Z"
        fill="black"
      />
      <path
        d="M595 317C594.448 317 594 317.448 594 318V320H596V318C596 317.448 595.552 317 595 317Z"
        fill="black"
      />
      <path
        d="M601 317C600.448 317 600 317.448 600 318V320H602V318C602 317.448 601.552 317 601 317Z"
        fill="black"
      />
      <path
        d="M605.991 329H542.009C541.449 329 541 328.495 541 327.874V322.126C541 321.501 541.453 321 542.009 321H605.991C606.551 321 607 321.505 607 322.126V327.874C607.004 328.495 606.551 329 605.991 329Z"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M607.5 324.751C631.007 332.616 656.166 336.877 682.32 336.877C708.793 336.877 734.247 332.511 758 324.461"
        stroke="black"
        strokeWidth="1.72"
      />
      <path
        d="M607.5 298.094C631.007 305.96 656.166 310.221 682.32 310.221C708.793 310.221 734.247 305.855 758 297.805"
        stroke="black"
        strokeWidth="1.72"
      />
      <path
        d="M543.748 426.72V457.597C543.748 458.019 544.077 458.364 544.481 458.364H551.177C551.581 458.364 551.91 458.019 551.91 457.597V426.72C551.91 426.4 551.798 426.087 551.596 425.84L548.242 421.785C548.022 421.519 547.629 421.519 547.408 421.785L544.055 425.84C543.86 426.087 543.748 426.396 543.748 426.72Z"
        fill="white"
      />
      <path
        d="M541 426.305V458.208C541 458.644 541.322 459 541.718 459H548.282C548.678 459 549 458.644 549 458.208V426.305C549 425.974 548.89 425.651 548.692 425.396L545.405 421.206C545.189 420.931 544.804 420.931 544.588 421.206L541.3 425.396C541.11 425.651 541 425.97 541 426.305Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M510.598 426.72V457.597C510.598 458.019 510.927 458.364 511.33 458.364H518.027C518.43 458.364 518.76 458.019 518.76 457.597V426.72C518.76 426.4 518.647 426.087 518.445 425.84L515.092 421.785C514.871 421.519 514.479 421.519 514.258 421.785L510.904 425.84C510.706 426.087 510.598 426.396 510.598 426.72Z"
        fill="white"
      />
      <path
        d="M510 426.305V458.208C510 458.644 510.323 459 510.718 459H517.282C517.677 459 518 458.644 518 458.208V426.305C518 425.974 517.89 425.651 517.692 425.396L514.405 421.206C514.189 420.931 513.804 420.931 513.588 421.206L510.301 425.396C510.106 425.651 510 425.97 510 426.305Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path d="M555.301 445.57H466.721V451.475H555.301V445.57Z" fill="white" />
      <path
        d="M555 445H467V451H555V445Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path d="M555.301 430.922H466.721V437.744H555.301V430.922Z" fill="white" />
      <path
        d="M555 431H467V437H555V431Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M545 433C544.446 433 544 433.446 544 434C544 434.554 544.446 435 545 435C545.554 435 546 434.554 546 434C546 433.452 545.554 433 545 433Z"
        fill="black"
      />
      <path
        d="M545 447C544.446 447 544 447.446 544 448C544 448.554 544.446 449 545 449C545.554 449 546 448.554 546 448C546 447.452 545.554 447 545 447Z"
        fill="black"
      />
      <path
        d="M514 433C513.446 433 513 433.446 513 434C513 434.554 513.446 435 514 435C514.554 435 515 434.554 515 434C515 433.452 514.554 433 514 433Z"
        fill="black"
      />
      <path
        d="M514 447C513.446 447 513 447.446 513 448C513 448.554 513.446 449 514 449C514.554 449 515 448.554 515 448C515 447.452 514.554 447 514 447Z"
        fill="black"
      />
      <path
        d="M492 273H20V459H492V273Z"
        fill="#F5F5F5"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M511.918 283H0.917969L56.1465 138H456.689L511.918 283Z"
        fill="#FFCC00"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_4148_206804)">
        <path
          d="M511.918 283H0.917969L56.1465 138H456.689L511.918 283Z"
          fill="white"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
      <mask id="path-33-inside-1_4148_206804" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M468.999 260H382.278L369.413 192L445.685 192L468.999 260ZM444.314 188L368.657 188L355.792 120H420.999L444.314 188ZM364.586 188L351.721 120H285.137L287.45 188L364.586 188ZM378.207 260L365.342 192L287.586 192L289.899 260H378.207Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M468.999 260H382.278L369.413 192L445.685 192L468.999 260ZM444.314 188L368.657 188L355.792 120H420.999L444.314 188ZM364.586 188L351.721 120H285.137L287.45 188L364.586 188ZM378.207 260L365.342 192L287.586 192L289.899 260H378.207Z"
        fill="#F5F5F5"
      />
      <path
        d="M382.278 260L380.313 260.372C380.492 261.316 381.317 262 382.278 262V260ZM468.999 260V262C469.645 262 470.252 261.688 470.627 261.162C471.002 260.637 471.101 259.962 470.891 259.351L468.999 260ZM369.413 192V190C368.818 190 368.253 190.265 367.873 190.724C367.493 191.183 367.337 191.787 367.448 192.372L369.413 192ZM445.685 192L447.577 191.351C447.3 190.543 446.54 190 445.685 190V192ZM368.657 188L366.691 188.372C366.87 189.316 367.695 190 368.657 190V188ZM444.314 188V190C444.96 190 445.566 189.688 445.941 189.163C446.317 188.637 446.415 187.962 446.206 187.351L444.314 188ZM355.792 120V118C355.196 118 354.632 118.265 354.252 118.724C353.872 119.183 353.716 119.787 353.827 120.372L355.792 120ZM420.999 120L422.891 119.351C422.614 118.543 421.854 118 420.999 118V120ZM351.721 120L353.686 119.628C353.507 118.684 352.682 118 351.721 118V120ZM364.586 188V190C365.181 190 365.746 189.735 366.126 189.276C366.506 188.817 366.661 188.213 366.551 187.628L364.586 188ZM285.137 120V118C284.594 118 284.076 118.22 283.699 118.61C283.322 119 283.119 119.526 283.138 120.068L285.137 120ZM287.45 188L285.451 188.068C285.487 189.146 286.372 190 287.45 190L287.45 188ZM365.342 192L367.308 191.628C367.129 190.684 366.304 190 365.342 190V192ZM378.207 260V262C378.803 262 379.367 261.735 379.747 261.276C380.127 260.817 380.283 260.213 380.172 259.628L378.207 260ZM287.586 192V190C287.043 190 286.524 190.22 286.148 190.61C285.771 191 285.568 191.526 285.587 192.068L287.586 192ZM289.899 260L287.9 260.068C287.936 261.145 288.82 262 289.899 262V260ZM382.278 262H468.999V258H382.278V262ZM367.448 192.372L380.313 260.372L384.243 259.628L371.378 191.628L367.448 192.372ZM445.685 190L369.413 190V194L445.685 194V190ZM470.891 259.351L447.577 191.351L443.793 192.649L467.108 260.649L470.891 259.351ZM368.657 190L444.314 190V186L368.657 186V190ZM353.827 120.372L366.691 188.372L370.622 187.628L357.757 119.628L353.827 120.372ZM420.999 118H355.792V122H420.999V118ZM446.206 187.351L422.891 119.351L419.108 120.649L442.422 188.649L446.206 187.351ZM349.756 120.372L362.62 188.372L366.551 187.628L353.686 119.628L349.756 120.372ZM285.137 122H351.721V118H285.137V122ZM289.448 187.932L287.136 119.932L283.138 120.068L285.451 188.068L289.448 187.932ZM364.586 186L287.45 186L287.45 190L364.586 190V186ZM363.377 192.372L376.242 260.372L380.172 259.628L367.308 191.628L363.377 192.372ZM287.586 194L365.342 194V190L287.586 190L287.586 194ZM291.897 259.932L289.585 191.932L285.587 192.068L287.9 260.068L291.897 259.932ZM378.207 258H289.899V262H378.207V258Z"
        fill="black"
        mask="url(#path-33-inside-1_4148_206804)"
      />
      <rect
        x="1"
        y="283"
        width="511"
        height="4"
        fill="#D9D9D9"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect width="73" height="131" transform="translate(290 328)" fill="#DDDDDD" />
      <rect
        x="290"
        y="328"
        width="73"
        height="131"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M353 372L353 416"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="318" y="337" width="16" height="113" fill="white" stroke="black" strokeWidth="2" />
      <rect width="73" height="67" transform="translate(387 328)" fill="white" />
      <g clipPath="url(#clip2_4148_206804)">
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="387"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="421"
          y="333"
          width="6"
          height="3"
          fill="black"
          stroke="black"
          strokeLinejoin="round"
        />
        <path d="M424 333V395" stroke="black" strokeWidth="2" />
        <path d="M460 364H387" stroke="black" strokeWidth="2" />
      </g>
      <rect
        x="387"
        y="328"
        width="73"
        height="67"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="383"
        y="395"
        width="81"
        height="4"
        fill="#D9D9D9"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect y="-60" width="256" height="619" fill="white" fillOpacity="0.8" />
      <line
        x1="256"
        y1="492"
        x2="256"
        y2="87"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M541.356 27.8182L552.33 16.8438"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M477.453 91.7188L466.479 102.693"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M477.402 28.416L466.416 17.4297"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M541.402 92.4141L552.389 103.4"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M509.41 15.6037L509.395 -0.296875"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M509.477 105.297L509.488 121.202"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M464.599 60.4192L448.694 60.4075"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M554.288 60.4814L570.189 60.4973"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M485.841 84.618C499.05 97.8269 520.45 97.8426 533.639 84.653C546.829 71.4634 546.813 50.0632 533.604 36.8543C520.395 23.6454 498.995 23.6298 485.806 36.8193C472.616 50.0089 472.632 71.4091 485.841 84.618Z"
        fill="#FFCC00"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M670.168 110.27C669.59 110.241 669.011 110.241 668.433 110.27C666.062 103.222 661.401 97.0743 655.124 92.7124C648.847 88.3504 641.278 86 633.508 86C625.737 86 618.168 88.3504 611.891 92.7124C605.614 97.0743 600.953 103.222 598.582 110.27C598.004 110.27 597.425 110.27 596.847 110.27C593.717 110.268 590.618 110.853 587.726 111.992C584.834 113.131 582.205 114.801 579.991 116.908C577.777 119.014 576.019 121.515 574.82 124.269C573.62 127.022 573.002 129.973 573 132.954C572.995 139.01 575.495 144.824 579.959 149.137C584.422 153.451 590.489 155.916 596.847 156H670.168C676.527 155.924 682.597 153.46 687.06 149.145C691.522 144.829 694.016 139.011 694 132.954C693.996 126.936 691.483 121.167 687.014 116.913C682.546 112.659 676.486 110.27 670.168 110.27Z"
        fill="white"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_4148_206804">
        <rect width="636" height="493" fill="white" />
      </clipPath>
      <clipPath id="clip1_4148_206804">
        <rect width="255" height="147" fill="white" transform="translate(1 137)" />
      </clipPath>
      <clipPath id="clip2_4148_206804">
        <rect width="73" height="67" fill="white" transform="translate(387 328)" />
      </clipPath>
    </defs>
  </>
);
